import React from 'react';
import { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
  Button,
} from 'reactstrap';
import { Modal as antdModal } from 'antd';
import DataTable from 'react-data-table-component';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { withNamespaces } from 'react-i18next';

import { ApiContext } from 'src/utils/ApiContext';
import { notification } from 'antd';

export default withNamespaces()(ModalOrders);

function ModalOrders(props) {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const { t } = props;

  const context = React.useContext(ApiContext);
  // const widRef = React.createRef();

  const { showOrders, fetchApi, user } = context;

  dayjs.extend(utc);
  dayjs.extend(timezone);

  useEffect(() => {
    if (showOrders) {
      setLoading(true);

      let route = `/api/order/list`
      fetchApi(route, {
        uid: user.uid,
      })
        // .then(res => {
        //   console.log(res)
        // })
        .then(data => {
          console.log(route, data)
          // // 測試
          // // 加入一筆假資料
          // data.orders.push({
          //   id: 0,
          //   uid: 0,
          //   coin: -100000,
          //   status: null,
          //   createdAt: 0,
          //   testFail: 0,
          //   otc_id: null,
          // })
          setTableData(data.orders);
        })
        .catch(err => console.error('API error', err))
        .finally(() => setLoading(false));
    }
  }, [showOrders, fetchApi, user]);


  // 綜合結果 aka 備註
  const resultMap = {
    no_id: t('ModalOrders.resultMap.no_id'),
    not_support: t('ModalOrders.resultMap.not_support'),
    topup: t('ModalOrders.resultMap.topup'),
    remit: t('ModalOrders.resultMap.remit'),
    old_remit: t('ModalOrders.resultMap.old_remit'),
    zero_amount: t('ModalOrders.resultMap.zero_amount')
  }
  const getResult = (row) => {
    let result = resultMap.not_support
    if (row.coin < 0) {
      // 下分
      if (row.otc_id) {
        // 有記錄到 ID
        result = resultMap.remit
      } else {
        // 沒紀錄
        if (row.status === null) {
          result = resultMap.no_id
        } else {
          result = resultMap.old_remit
        }
      }
    } else if (row.coin > 0) {
      // 上分直接查
      result = resultMap.topup
    } else {
      // 0 元查屁
      result = resultMap.zero_amount
    }
    return result
  }

  const statusMap = {
    pending: t('ModalOrders.statusMap.pending'),
    success: t('ModalOrders.statusMap.success'),
    failed: t('ModalOrders.statusMap.failed'),
    testFail: t('ModalOrders.statusMap.IntentionFailed'),
    waitingMatchPay: t('ModalOrders.statusMap.waitingMatchPay')
  }
  const getStatus = (row) => {
    let ret = statusMap.pending
    if (row.status === 1) {
      ret = statusMap.success
    } else if (row.status === 0) {
      ret = statusMap.failed
      if (row.testFail === 1) {
        ret = statusMap.testFail
      }
    } else {
      // pending
      // if (row.coin > 0) {
      //   // user not continued
      //   ret = statusMap.pending
      // } else {
      //   // matchpay not responded
      //   ret = statusMap.waitingMatchPay
      // }

      // matchpay not responded
      ret = statusMap.waitingMatchPay
    }
    return ret
  }

  const columns = [
    // { name: '#', selector: (_, index) => index + 1, width: '60px' },
    // { name: 'uid', selector: row => row.uid, sortable: true },
    { id: 'id', name: t('ModalOrders.OrderId'), selector: row => row.id, sortable: false, width: '280px' },
    {
      id: 'coin',
      name: t('ModalOrders.coin'),
      selector: row => row.coin,
      sortable: true,
      width: '95px',
      cell: row => {
        const amount = row.coin || 0;
        const formatted = amount.toLocaleString(); // => 1,234
        const isNegative = amount < 0;
        return (
          <span style={{ color: isNegative ? 'red' : undefined }}>
            ${formatted}
          </span>
        );
      }
    },
    {
      id: 'status',
      name: t('ModalOrders.status'),
      selector: row => row.status,
      sortable: false,
      width: '115px',
      cell: row => {
        // 訂單狀態
        let status = getStatus(row);

        return (
          <span style={{ color: row.status === 1 ? 'green' : 'red' }}>
            {status}
          </span>
        )
      },
    },
    {
      id: 'createdAt',
      name: t('ModalOrders.createdAt'),
      selector: row => row.createdAt,
      sortable: true,
      width: '135px',
      cell: row => (
        <span>{dayjs.utc(row.createdAt).tz('Asia/Taipei').format('YYYY-MM-DD HH:mm')}</span>
      )
    },
    // { name: 'testFail', selector: row => row.testFail },
    {
      id: 'otc_id', name: 'E Pay ID', width: '280px',
      selector: row => {
        if (row.otc_id) return row.otc_id
        else {
          let result = getResult(row)
          if (result === resultMap.no_id || result === resultMap.old_remit)
            return result
          // else if (result === resultMap.topup)
          //   return resultMap.no_id
          else
            return null
        }
      },
      sortable: false
    },
    {
      id: 'matchpay.query',
      name: 'MatchPay',
      cell: row => {
        let result = getResult(row)

        if (result === resultMap.topup || result === resultMap.remit)
          return (
            <div>
              <Button
                size="sm"
                color={result === resultMap.topup ? "success" : "info"}
                onClick={() => handleQuery(row)}
              >
                {t('ModalOrders.query')}
              </Button>
            </div>
          )
        else if (result === resultMap.zero_amount) {
          return (
            <div>
              {result}
            </div>
          )
        } else {
          return null
        }
      },
      ignoreRowClick: true,
    },
    {
      id: 'order.finish',
      name: t('ModalOrders.GameDemo'),
      cell: row => {
        if (row.status !== 1)
          return (
            <Button
              size="sm"
              color="warning"
              onClick={() => showConfirm(row)}
            >
              {t('ModalOrders.finishOrder')}
            </Button>
          )
        else {
          return null
        }
      },
      ignoreRowClick: true,
    }
  ];

  const toggleFunc = () => {
    context.setShowOrders(false);
  };

  const handleQuery = (row) => {
    // setLoading(true);
    const key = 'loading-notification';
    notification.info({
      key,
      message: t('ModalOrders.queryOTC'),
      description: t('ModalOrders.quering'),
      duration: 180,
      placement: 'top',
    })
    fetchApi('/api/order/queryOTC', { id: row.id })
      .then(data => {
        if (data === null) {
          return
        }

        console.log(`訂單 ${row.id} 查詢結果:`, data);

        const response = data.response;

        // 你可以在這裡彈出新 Modal、顯示 Toast、或更新 tableData
        if (response.Status === 1) {
          notification.success({
            message: t('ModalOrders.queryOTC'),
            description: JSON.stringify(data.response),
            duration: 30,
            placement: 'top',
          });
        } else {
          notification.warning({
            message: t('ModalOrders.queryOTC'),
            description: JSON.stringify(data.response),
            duration: 30,
            placement: 'top',
          });
        }
      })
      // .catch(err => console.error('查詢錯誤', err))
      .finally(() => {
        // setLoading(false)
        notification.close(key)
      });
  };

  const handleFinish = (id) => {
    // const key = 'loading-notification';
    // notification.info({
    //   key,
    //   message: t('ModalOrders.queryOTC'),
    //   description: t('ModalOrders.quering'),
    //   duration: 180,
    //   placement: 'top',
    // })
    fetchApi('/api/order/finish', { id })
    // .then(data => {
    //   if (data === null) {
    //     return
    //   }
    //   console.log(`訂單 ${row.id} 查詢結果:`, data);
    //   const response = data.response;
    // })
    // .catch(err => console.error('查詢錯誤', err))
    // .finally(() => {
    // notification.close(key)
    // });
  };

  const showConfirm = (row) => {
    antdModal.confirm({
      title: t('Home.ConfirmTitle'),
      content: `你確定要強制完成訂單 ($${row.coin?.toLocaleString() || 0}) 嗎？`,
      okText: t('Home.ConfirmButton'),
      cancelText: t('Home.CancelButton'),
      onOk() {
        handleFinish(row.id);
      },
    });
  };

  return (
    <Modal
      isOpen={context.showOrders}
      toggle={toggleFunc}
      size="xl"
      zIndex={1}
    >
      <ModalHeader toggle={toggleFunc}>{t('ModalOrders.Orders')}</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center">
            <Spinner color="primary" />
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={tableData}
            progressPending={loading}
            pagination
            highlightOnHover
            responsive
            dense
            noHeader
            defaultSortFieldId={'createdAt'}
            defaultSortAsc={false}
          // theme="compact"
          // customStyles={customStyles}
          />
        )}
      </ModalBody>
    </Modal >
  );
};
